<template>
  <div>
    <b-navbar variant="faded" type="dark" class="contentHeader p-0 w-100">
      <!-- sidebar-brand  -->
      <div class="sidebar-item sidebar-header d-flex flex-nowrap">
        <div class="user-pic">
          <img
            class="img-responsive img-rounded"
            v-bind:src="userPic"
            alt="User picture"
          />
        </div>
        <div class="user-info">
          <span class="user-name" id="logegdUser">{{ currentUser }}</span>
        </div>
      </div>
      <!---Search Bar--->
      <div class="searchWrapper">
        <div class="sidebar-search">
          <div class="input-group">
            <div class="input-group-append">
              <span class="input-group-text" id="searchTextBtn">
                <img v-bind:src="search" class="icon" />
              </span>
            </div>
            <input
              type="text"
              ref="searchBox"
              class="form-control search-menu"
              id="searchBox"
              v-model="searchBox"
              v-on:input="formValidationHandler"
              placeholder="Search..."
            />
            <div class="input-group-append">
              <span
                type="button"
                id="clearButton"
                class="input-group-text"
                @click="clearSearch"
              >
                <img v-bind:src="cancelWhite" class="icon cancelWhite" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <!--Links-->
      <div class="linksWrapper">
        <b-nav align="right">
          <b-nav-item title="Home">
            <router-link to="/dashboard">
              <i class="fas fa-home" style="top: 2px;position: relative;"></i>
            </router-link>
          </b-nav-item>

          <b-nav-item title="Administrative Settings">
            <router-link to="/userManagement">
              <img
                v-bind:src="settings"
                class="icon"
                style="width: 25px;height: 25px;"
              />
            </router-link>
          </b-nav-item>

          <b-nav-item title="Change Password">
            <router-link to="/changePassword">
              <i class="fas fa-edit" style="top: 2px;position: relative;"></i>
            </router-link>
          </b-nav-item>

          <b-nav-item title="Logout">
            <!-- <router-link to="/logout"> -->
            <img v-bind:src="logoutImg" @click="onSignout" />
            <!-- </router-link> -->
          </b-nav-item>
        </b-nav>
      </div>
    </b-navbar>
    <HomeSidePane @clicked="onClickChild" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeSidePane from "@/components/Home/sidePane.vue";
import userPic from "@/assets/img/icons/user_white.png";
import logoutImg from "@/assets/img/icons/logout.png";
import settings from "@/assets/img/icons/--09.png";
import search from "@/assets/img/icons/search.png";
import CancelWhite from "@/assets/img/icons/cancelWhite.svg";
import { userInputValidation } from "@/helpers/form-validation.js";

export default {
  name: "SecondaryHeader",
  components: {
    HomeSidePane,
  },
  // props:{
  //   collapsed: {
  //     type: Boolean,
  //     default: false
  //   },
  // },
  data() {
    return {
      logoutImg: logoutImg,
      settings: settings,
      search: search,
      cancelWhite: CancelWhite,
      userPic: userPic,
      collapsed: false,
      searchBox: "",
      userDetails: sessionStorage.getItem("getUserData")
        ? JSON.parse(sessionStorage.getItem("getUserData"))
        : "",
    };
  },
  computed: {
    currentUser() {
      let userInfo = this.userDetails;
      let username = null;
      if (userInfo != null) {
        username = userInfo.username;
        (username = username.replace(".", " ")),
          (username = username.replace("_", " "));
      } else {
        username = userInfo;
      }
      return username;
    },
  },
  created() {
    this.checkPage();
  },
  methods: {
    userInputValidation,
    formValidationHandler() {
      let les = this.userInputValidation(this.searchBox);
      // console.log("input valueeee", les);
      this.searchBox = les;
    },
    clearSearch() {
      this.searchBox = "";
      this.$refs.searchBox.focus();
    },
    onClickChild(value) {
      // console.log('collapse=-=',value) // someValue
      this.$emit("openSidepane", value);
    },
    checkPage() {
      this.collapsed = true;
    },
    onSignout() {
      if (confirm("Are you sure you want to log out?") == true) {
        this.$router.push("/logout");
      }
    },
  },
};
</script>

<style lang="scss">
.contentHeader {
  width: 100%;
  background: rgb(52, 63, 75);
  height: 61px;
  color: $color-white;
}

/******User Profile****** */
.sidebar-header {
  .user-pic {
    img {
      -o-object-fit: cover;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }

    width: 40px;
    height: 40px;
    border-radius: 23px;
    background-color: #cccccc;
    margin: 10px 10px 10px 20px;
  }

  .user-info {
    margin: auto 0;
    span {
      text-transform: capitalize;
    }

    font-size: 15px;
    line-height: 18px;
    color: #e4ebf7;
    // margin-top: 15px;
    // margin-right: 15px;
    font-weight: 600;
  }

  padding: 0px;
  overflow: hidden;
  background: rgb(46, 56, 187);
  top: -2px;
  position: relative;
  width: 14vw;
}

/*-----Search Bar----*/
.sidebar-search .input-group-text {
  background: transparent;
  border: transparent;
}

.sidebar-search .input-group-text i {
  color: $color-white;
}

.search-menu {
  background: transparent;
  border: transparent;
  font-size: 13px;
  line-height: 18px;
  color: #a8bec9;
}

/*------Page Links------*/
.badge-warning {
  color: $color-white;
  background-color: $color-red;
  font-size: 10px;
  vertical-align: top;
  padding-right: 0.4em;
  padding-left: 0.4em;
}

.searchWrapper {
  border-radius: 5px;
  background: #343f4b;
  position: relative;
  left: 1%;
}
.searchWrapper #searchBox {
  background: #343f4b;
  border: none;
}
.searchWrapper #searchBox:focus {
  background: #fff;
}
.linksWrapper {
  ul {
    li {
      a {
        img {
          position: relative;
          width: 16px;
          height: 16px;
        }

        i {
          position: relative;
          width: 16px;
          height: 16px;
          color: #a8bec9;
          position: relative;
        }

        display: block;
        color: $color-white;
        text-align: center;
        padding: 8px;
        text-decoration: none;
      }

      float: left;
      top: 0;
      position: relative;
    }

    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: transparent;
    float: right;
  }

  position: absolute;
  right: 2%;
}
.cancelWhite {
  width: 10px;
  height: 10px;
  max-height: 10px;
  max-width: 10px;
}
</style>
